module.exports = __webpack_public_path__ + "assets/img/drawItem7-8e99e4ac.png";